import LegalPageLayout, { LegalSection } from "@/components/LegalPageLayout";
import { PHONE_DISPLAY, EMAIL } from "@/constants/business";

export default function MentionsLegalesPage() {
  return (
    <LegalPageLayout
      title="Mentions légales"
      path="/mentions-legales"
      description="Mentions légales du site Express Delivery — transport et déménagement au Havre."
      testId="mentions-legales-page"
    >
      <LegalSection title="Éditeur du site">
        <p>Express Delivery — Transport, livraison, manutention, déménagement, débarras et prestations logistiques associées pour particuliers, professionnels et institutions.</p>
        <p>Exploitant : Yassine Doukari — Entrepreneur individuel (EI)</p>
        <p>SIREN : 853 818 037 — SIRET : 853 818 037 00022</p>
        <p>Adresse : 47 rue Jean Dubuffet, 76600 Le Havre — France</p>
        <p>Directeur de la publication : Yassine Doukari</p>
        <p>Téléphone : {PHONE_DISPLAY}</p>
        <p>Email : {EMAIL}</p>
      </LegalSection>
      <LegalSection title="Activité">
        <p>
          Transport de meubles et d'objets volumineux, déménagement, camion avec chauffeur, aide à la
          manutention, transport d'électroménager, livraison d'achats entre particuliers, débarras, groupage et
          transport longue distance.
        </p>
      </LegalSection>
      <LegalSection title="Propriété intellectuelle">
        <p>
          L'ensemble des contenus originaux de ce site (textes, visuels, logo) est la propriété d'Express Delivery.
          Toute reproduction non autorisée est interdite. Les marques citées (Leboncoin, Facebook Marketplace)
          appartiennent à leurs propriétaires respectifs et sont mentionnées à titre purement descriptif, sans
          affiliation ni partenariat.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
